import { createEvent, createStore } from 'effector';
import { AiMentionType } from '@nx-frontend/shared/types';

interface AiHelperOpenOptions {
  mention?: {
    title: string;
    type: AiMentionType;
    globalId: string;
    url?: string;
  };
}

export interface AiHelperState {
  visible: boolean;
  openOptions?: AiHelperOpenOptions;
  /**
   * Turn ai helper into Agent mode and uses specified agent settings
   */
  agentId?: string;
  /**
   * if set together with agentId, then agent mode will be opened with existing thread
   * from activeThreadId instead of starting an agent
   */
  openExistingAgentThread?: boolean;
}

export const aiHelperInitialState: AiHelperState = {
  visible: false,
};

export const $aiHelper = createStore(aiHelperInitialState);

export const showAiHelperEvent = createEvent<{
  agentId?: string;
  openExistingAgentThread?: boolean;
} | void>();

$aiHelper.on(showAiHelperEvent, (state, data = {}) => {
  return {
    ...state,
    visible: true,
    agentId: data?.agentId,
    openExistingAgentThread: data?.openExistingAgentThread,
  };
});

export const hideAiHelperEvent = createEvent<{
  apiHost: string;
  sessionId: string;
  workspaceId: string;
}>();

$aiHelper.on(hideAiHelperEvent, (state) => {
  return {
    ...state,
    visible: false,
  };
});

export const setAiOpenOptionsEvent = createEvent<AiHelperOpenOptions>();

$aiHelper.on(setAiOpenOptionsEvent, (state, payload) => {
  if (Object.keys(payload).length) {
    return { ...state, visible: true, openOptions: payload };
  }
  return { ...state, openOptions: payload };
});
